import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {
    EmbeddedReportModelFieldInputTypeHandlerComponent
} from './embedded-report-model-field-input-type-handler.component';
import {FileUploadModule} from '../../../../../../../components/common/file-upload/file-upload.module';
import {ButtonModule} from '../../../../../../core/component/button/button.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FileUploadModule,
        ButtonModule,
    ],
    declarations: [
        EmbeddedReportModelFieldInputTypeHandlerComponent,
    ],
    exports: [
        EmbeddedReportModelFieldInputTypeHandlerComponent,
    ],
})
export class EmbeddedReportModelFieldInputTypeHandlerModule {}
